<div class="container-fluid">
    <div class="row">
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-9">
                    <h5 class=""><i class="fa fa-building"></i><b> My Accounts Information </b></h5>
                </div>
                <div class="col-3 text-right">
                    <strong class="text-right" style="color:rgb(253, 207,76 );">{{user?.UserName}}</strong>
                </div>
            </div>
            <table class="table table-sm table-striped" style="border-top:none;">
                <thead class="" style="background:white!important;border-top:none;">
                    <tr style="vertical-align:middle;">
                        <th scope="col">Account Number</th>
                        <th scope="col">Account Name</th>
                        <!--<th scope="col">Trading Name</th>
            <th scope="col">Registration Number</th>
            <th scope="col">Lead User</th>
            <th scope="col">Carrier Type</th>-->
                        <th scope="col">Account Balance</th>
                        <th scope="col">Account Status</th>
                        <th class="btn-show hgt-btn button-head" style="width:300px">
                            <a [routerLink]="['/carrier/account/add']">
                                <button title="Add a New Carrier Account" class="btn-add btn btn-primary " type="submit" style="width: auto;">Add Account</button>
                            </a>
                            <a *ngIf="onboarding == 1">
                                &nbsp;<button class="btn-add btn btn-primary " type="submit" data-toggle="modal" data-target="#myModal" style="width: auto;" title="Import existing carrier from legacy system" (click)="setCarrierCodeFocus()">
                  Import Account
                </button>
                            </a>
                        </th>
                    </tr>
                </thead>
                <tr *ngFor="let acc of listAccounts | paginate: { itemsPerPage: 10, currentPage: page }">
                    <!-- <td>{{acc.account_number}}</td> -->
                    <td><a [routerLink]="['/carrier/account/edit/' + acc.id + '/' + 1]" style="color:#1D3F94; text-decoration: underline;"><span title ="View account details">{{acc.account_number}}</span></a></td>
                    <td>{{acc.account_name}}</td>
                    <!--<td>{{acc.trading_name}}</td>
          <td>{{acc.reg_number}}</td>
          <td>{{acc.link_person}}</td>
          <td>{{acc.carrier_type}}</td>-->
                    <td>{{acc.account_balance ? (acc.account_balance | currencyFormat) : 'R 0.00' }}</td>
                    <td>{{acc.status}}</td>
                    <td class="btn-show">
                        <select class="form-control" (change)="selectOptionList(select.value,acc)" #select>
              <option id="selectList">Select</option>
              <!-- <option value="0" *ngIf="!isReadOnly(acc.status) && acc.status_id != AccountStatus2">Edit Account</option> -->
              <option value="0" *ngIf="acc.status_code == 'Submitted_1' || acc.status_code == 'Approved'">My Permits</option>
              <option value="1" *ngIf="acc.status_code == 'Submitted_1' || acc.status_code == 'Approved'">My Applications</option>
              <option value="2" *ngIf="acc.status_code == 'Saved_1' || acc.status_code == 'Submitted_1' || acc.status_code == 'Approved' || acc.status_code == 'AddInfo_1'">View Account</option>
              <option value="3" *ngIf="acc.status_code == 'Saved_1' || acc.status_code == 'Submitted_1' || acc.status_code == 'Approved' || acc.status_code == 'AddInfo_1'">Edit Account</option>
              <option value="4" *ngIf="acc.lead_user_id == user.Id && (acc.status_code == 'Saved_1' || acc.status_code == 'AddInfo_1')">Delete Account</option>
              <option value="5" *ngIf="acc.status_code == 'Submitted_1'">Un-Submit</option>
              <option value="6" *ngIf="acc.status_code == 'Submitted_1' || acc.status_code == 'Approved'">Account Statement</option>
              <option value="7" *ngIf="acc.lead_user_id == user.Id && acc.status_code == 'Approved'">Link Consultants</option>
              <option value="8" *ngIf="acc.status_code == 'Approved'">Annual Compliance</option>
              <option value="9" *ngIf="acc.status_code == 'Approved' && paygateEnabled">Fund Account</option>
            </select>
                        <!-- <a [routerLink]="['/carrier/account/edit',acc.id]" *ngIf="!isReadOnly(acc.status)"><span title="Edit Carrier Account" style="margin: 0%" class="btn btn-success btn-sm"><i class="fa fa-pencil fa-fw"></i></span></a> -->
                        <!-- <button  *ngIf="isReadOnly(acc.status)" [routerLink]="['/carrier/account/edit',acc.id]" title="View Submitted Carrier Account" class="btn btn-primary btn-sm"><i class="fa fa-list" aria-hidden="true"></i></button> -->
                        <!-- <a (click)="viewAcc(acc,'/carrier/permit/application')"><span title="View Permits" style="margin: 0%" class="btn btn-warning btn-sm"><i class="fa fa-files-o fa-fw"></i></span></a>
            <a [routerLink]="['/carrier/permit/application/renew',acc.id]"><span title="Renew Permit" style="margin: 0%" class="btn btn-danger btn-sm"><i class="fa fa-refresh fa-fw"></i></span></a> -->
                    </td>
                </tr>
                <tfoot>
                    <tr *ngIf="listAccounts.length > 4">
                        <td colspan="9" class="rm-brd">
                            <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;color:#1D3F94"></pagination-controls>
                        </td>
                    </tr>
                    <tr *ngIf="isEmpty">
                        <td colspan="9" class="rm-brd">
                            <span class="text-info text-small">No Accounts have been created yet, please add or import an existing account.</span>
                        </td>
                    </tr>
                </tfoot>
                <br>
            </table>
            <p class="use-mouse" style="color:#1D3F94">Click on the underlined link to view Account Information.</p>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <!--Manage Timetable-->
            <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-hidden="true" style="margin: 12% auto;">
                <div class="modal-dialog modal-lg" role="document" style="margin-bottom: 0%; padding-bottom: 0%;">
                    <div class="modal-content" style="border-style: solid; border-width: 1px; border-color: #1D3F94; padding:0%; background-color:#ffffff;">
                        <!-- <div class="modal-header">

              <button type="button" class="close" data-dismiss="modal" #closebutton aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
                        <div class="modal-body modal-lg" style="height:300px;">
                            <!-- <label style="margin-top: 30px;margin-left:50px">Carrier Code : </label> -->
                            <!-- Import existing carrier from legacy system -->
                            <h5 style="text-align: center; margin-top:12px; color: #1D3F94;">IMPORT CARRIER FROM LEGACY SYSTEM</h5><br/>
                            <div style="margin-left: 100px">
                                <input type="text" placeholder="Enter Account Number" id="carrierCode" name="carrierCode" #carrierCode (keypress)="checkKey($event)" autofocus/>
                                &nbsp;<button id="searchButton" class="btn btn-sm m-clr" style="color: white !important" (click)="fetchCarrier(carrierCode.value)">Search</button>

                                <div><label *ngIf="emptyCarrier == true" style="color: red;">{{errorMessage}}</label></div>
                                <div *ngIf="fetchedCarrier == true" style="margin-top: 30px;"><label><b>Carrier Name: </b><span style="font-weight:200">{{carrierName}}</span></label></div>
                                <div *ngIf="fetchedCarrier == true"><label><b>Trading Name: </b><span style="font-weight:200">{{carrierTradingName}}</span></label></div>
                                <div *ngIf="fetchedCarrier == true"><label><b>Carrier Type: </b><span style="font-weight:200">{{carrierType}}</span></label></div>
                                <div *ngIf="fetchedCarrier == true"><label><b>Country: </b><span style="font-weight:200">{{carrierCountry}}</span></label></div>
                            </div>
                        </div>
                        <div class="modal-footer" style="height: 65px; padding: 0%;">
                            <div clas="row">
                                <div class="col-12" style="padding: 0%;">
                                    <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" style="color: white !important;" (click)="cancelCarrier()" data-dismiss="modal">Cancel</button>
                                    <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" style="color: white !important;" (click)="importCarrier()" [disabled]="!fetchedCarrier" data-dismiss="modal">Import</button>
                                    <label *ngIf="fetchedCarrier == true" style="color:#1D3F94; padding-right: 60px; padding-top: 15px">Confirm the carrier information is correct, then click the "Import" button   ...</label>
                                    <!-- <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Cancel</button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
